import React                from 'react'
import { 
    Container, 
    Content,
    ContactForm
}                           from './component'

const Contact = () => {
    return (
        <Container>
            <Content>
                <ContactForm />
            </Content>
        </Container>
    )
}

export default Contact; 
